// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__y10HP","h2":"Heading_h2__8OXKX","h3":"Heading_h3__kyiHg"};